export default function clearSelect(select) {
    for (let o of select.querySelectorAll('option')) {
        o.remove()
    }
}
